import mutateTimeAgo from 'src/lib/time_helpers';

function setupTimeAgo(node = document) {
  node.querySelectorAll('[data-timeago]').forEach(mutateTimeAgo);
}

setInterval(setupTimeAgo, 5000);

$(() => {
  setupTimeAgo();
});

App.mutation_observers.push((n) => {
  n.querySelectorAll('[data-timeago]').forEach(mutateTimeAgo);
});
